class Xref {

  constructor(element) {
    let term = element.getAttribute('data-xref');
    let lang = element.getAttribute('data-xref-lang');
    
    Xref.fetchRef(term, lang);  // Fetch the cross-reference
    
  }

  

  static async fetchRef(term, lang) {
    try {

      Xref.moreUrl = `/${lang}/work/${term}`;
      // Perform the fetch request
      const response = await fetch(`/${lang}/xref/${term}`, {
        headers: {
          'Accept': 'text/html'  // Expect HTML response
        }
      });

      // Check if the request was successful
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      // Extract the HTML from the response
      const html = await response.text();  // Use `.text()` to get HTML content

      // Call the static method to handle the HTML response
      Xref.displayRef(html);
    } catch (error) {
      console.error('Error fetching term:', error);
    }
  }

  static async displayRef(html) {
    try {
      // Insert the HTML content into the modal body
      document.querySelector('#xrefModal .modal-body').innerHTML = html;
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, 'text/html');
      console.log(doc);
      let showMoreUrlSwitch = doc.getElementById('no-href');
      console.log(showMoreUrlSwitch);
      
      if(!showMoreUrlSwitch) {
        console.log('Xref.moreUrl' + Xref.moreUrl);
        document.querySelector('#xrefModal #xref-more').href = Xref.moreUrl;
        document.querySelector('#xrefModal #xref-more').classList.remove('d-none');
      } else {
        document.querySelector('#xrefModal #xref-more').classList.add('d-none');
      }
      

      // Show the modal
      let xrefModal = document.getElementById('xrefModal');
      var bsModal = new bootstrap.Modal(xrefModal);
      bsModal.show();

    } catch (error) {
      console.error('Error displaying the cross-reference:', error);
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  // Select all elements that should trigger the Glossary/Modal
  let xrefTriggers = document.querySelectorAll('span.xref');

  xrefTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(event) {
      event.preventDefault();  // Prevent default link behavior if necessary

      // Instantiate Xref with the clicked element
      new Xref(event.currentTarget);
    });
  });
});
